import * as React from 'react'
import { PaginationLayout } from '../../../../pagination/paginationLayout'
import { ActualityPageData, PageResult } from '../../sharepointPageApi/types/pageData'
import { LinkBlockLayout } from '../linkBlockLayout'
import { AllNewsBlock } from './allNewsBlockWidget'


export type AllNewsBlockProps = AllNewsBlock & {
  children: PageResult<ActualityPageData>
}

export function AllNewsBlockLayout(props: AllNewsBlockProps) {
  const location = window.location
  const search = new URLSearchParams(location.search);
  const currentPage = search.get('p');
  const totalPages = Math.ceil(props.children.Total / props.children.PerPage)

  return (
    <>
      <LinkBlockLayout
          {...props}
          items={props.children.Resources.map(x => ({
              url: x.Resource.AbsolutePath,
              title: x.Resource.HeaderTitle,
              text: x.Resource.PublicationDate != null ? new Date(x.Resource.PublicationDate).toLocaleString('nl-NL', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              }) : ""
          }))}
          SVGIcon={{
            width: '22px',
            height: '18px'
          }}
          isActualityList={true}
      />
      <PaginationLayout
          currentPage={currentPage ? parseInt(currentPage) : 1}
          totalPages={totalPages}
          toPage={page => `${location.pathname}?${new URLSearchParams({page: page.toString()}).toString()}`}
      />
    </>
  );
}

